import { useState } from "react";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import AccountCircle from "@mui/icons-material/AccountCircle";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";
import Button from "@mui/material/Button";
import { getSSOUrl } from './Session';
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { useEffect } from "react";

function LoginPage() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [version, setVersion] = useState("");

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [redirectURL, setRedirectURL] = useState(null)

  const handleLogin = () => {
    setIsLoading(true);
    setError(null);

    getSSOUrl(username)
      .then((result) => {
        setRedirectURL(result)
        setSuccess(true);
      })
      .catch((error) => {
        setSuccess(false);
        setError(error.message);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetch("version.json", {
      method: "GET",
    })
      .then((response) => {
        response.json().then((data) => {
          setVersion(data.version);
        });
      })
      .catch((error) => {
        console.log(error);
        setVersion("Error");
      });
  }, []);

  useEffect(() => {
    if (success) {
      window.location.href = redirectURL;
    }
  }, [success, navigate]);
  if (success) {
    return null;
  } else {
    return (
      <Container maxWidth="lg" className="container">
        <br />
        <Paper spacing={3}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: "25vh" }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <h1>Login</h1>

              {error ? <b>{error}</b> : null}
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <AccountCircle />
                </Grid>
                <Grid item>
                  <TextField
                    id="input-with-icon-grid"
                    label="E-Mail"
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    disabled={isLoading}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <br />
              <div className="buttonWrapper">
                <Button
                  onClick={handleLogin}
                  color="primary"
                  variant="contained"
                  disabled={isLoading}
                  className={success ? "buttonSuccess" : ""}
                >
                  Login
                </Button>
                {isLoading && (
                  <CircularProgress size={24} className="buttonProgress" />
                )}
              </div>
            </Grid>
          </Grid>

          <Typography variant="body2" className="typeMargins">
            {version}
          </Typography>
        </Paper>
      </Container>
    );
  }
}

export default LoginPage;
